export default {
  session: sessionStorage,
  permanent: localStorage,
}
